import { getRunPodHealth } from '/web/store/data/user'

class WarmupManager {
  private lastWarmUpTime = 0
  private warmUpTimeout: NodeJS.Timeout | undefined
  private readonly THROTTLE_DURATION = 10000 // 10 seconds

  private async warmUp() {
    try {
      const runpodHealth = await getRunPodHealth()
      console.log('WarmupManager: success', runpodHealth)
    } catch (error) {
      console.warn('WarmupManager:', error)
    }
  }

  public triggerWarmUp() {
    const now = Date.now()
    const timeSinceLastWarmUp = now - this.lastWarmUpTime

    if (timeSinceLastWarmUp >= this.THROTTLE_DURATION) {
      // Fire immediately
      this.lastWarmUpTime = now
      this.warmUp()
    } else {
      // Wait for the remaining time, then fire
      const remainingTime = this.THROTTLE_DURATION - timeSinceLastWarmUp

      // Clear any existing timeout
      if (this.warmUpTimeout) {
        clearTimeout(this.warmUpTimeout)
      }

      this.warmUpTimeout = setTimeout(() => {
        this.lastWarmUpTime = Date.now()
        this.warmUp()
      }, remainingTime)
    }
  }

  public cleanup() {
    if (this.warmUpTimeout) {
      clearTimeout(this.warmUpTimeout)
      this.warmUpTimeout = undefined
    }
  }

  public getLastWarmUpTime() {
    return this.lastWarmUpTime
  }

  public getTimeSinceLastWarmUp() {
    return Date.now() - this.lastWarmUpTime
  }
}

// Export singleton instance
export const warmupManager = new WarmupManager()
